/**
 * A suggestion a buyer already released: `accepted` (draft order minted) or
 * `ordered` (the order system acked it). The board keeps it until the next
 * refresh (GEN-3119), read-only: its plan is already on an order.
 */
export function isReleasedStatus(status: string): boolean {
  return status === 'accepted' || status === 'ordered';
}
